import React from 'react';
import { GatedButton } from '../OrderItemEditActions';
import { getEditCapabilities } from '../../../utils/orderEditRules';

export default function EditOrderButton({ order, canManageOrders, generationIssue, onOpen }) {
  if (!canManageOrders || !order) return null;
  const { canEdit, reason } = getEditCapabilities(order, { generationIssue });
  return (
    <GatedButton
      allowed={canEdit}
      reason={reason}
      label="Edit order"
      onOpen={onOpen}
      size="slim"
    />
  );
}
